<template>
  <!-- 部门管理 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="部门名称">
              <a-input v-model="query.deptName" placeholder="请输入部门名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择" default-value="" v-model="query.status">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="2">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add
                >新增</a-button
              >
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="false"
    >
      <!-- <a-tag color="blue" slot="status" slot-scope="text">{{ text | statusFilter }}</a-tag> -->
      <span slot="status" slot-scope="text">
        <a-tag color="rgb(50, 205, 50" v-if="text == 1">正常</a-tag>
        <a-tag color="rgb(255, 99, 71)" v-else>禁用</a-tag>
      </span>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门编码" hasFeedback>
          <a-input
            :disabled="this.isUpdate"
            placeholder="部门编码"
            v-decorator="['deptCode', { rules: [{ required: true, message: '请输入部门编码' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门名称" hasFeedback>
          <a-input
            placeholder="部门名称"
            v-decorator="['deptName', { rules: [{ required: true, message: '请输入部门名称' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上级部门">
          <a-tree-select
            v-if="list"
            :tree-data="menuTreeData"
            v-decorator="[
              'pid',
              {
                initialValue: 0,
              },
            ]"
            style="width: 100%"
            :replace-fields="{ title: 'deptName', key: 'id', value: 'id' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择上级部门"
            tree-default-expand-all
          >
          </a-tree-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
          <a-select
            placeholder="请选择状态"
            v-decorator="['status', { rules: [{ required: true, message: '请选择状态' }], initialValue: 1 }]"
          >
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="同级别排序">
          <a-input-number
            :formatter="limitNumber"
            :parser="limitNumber"
            v-decorator="[
              'sort',
              { rules: [{ type: 'number', pattern: '/[^\d]/g', required: true, message: '请输入数字' }] },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const STATUS = {
  1: '正常',
  2: '禁用',
}
const treeData = [
  {
    title: 'Node1',
    value: '0-0',
    key: '0-0',
    children: [
      {
        value: '0-0-1',
        key: '0-0-1',
        scopedSlots: {
          // custom title
          title: 'title',
        },
      },
      {
        title: 'Child Node2',
        value: '0-0-2',
        key: '0-0-2',
      },
    ],
  },
  {
    title: 'Node2',
    value: '0-1',
    key: '0-1',
  },
]
const columns = [
  {
    title: '部门名称',
    dataIndex: 'deptName',
  },
  {
    title: '部门编码',
    dataIndex: 'deptCode',
  },
  {
    title: '同级别排序',
    dataIndex: 'sort',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'DeptList',
  data() {
    return {
      needPage: false,
      queryUrl: 'manager/dept/tree',
      addOrUpdateUrl: 'manager/dept',
      queryOneUrl: 'manager/dept',
      deleteUrl: 'manager/dept',
      query: {
        deptName: '',
        username: '',
        status: '',
        tenantId: '',
        realName: '',
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      treeData,
      treeExpandedKeys: [],
      value: undefined,
    }
  },
  filters: {
    statusFilter(key) {
      return STATUS[key]
    },
    permissionFilter(key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  computed: {
    menuTreeData: function () {
      return [
        {
          id: '0',
          deptName: '一级部门',
          children: this.filterTree(this.treeData, this.currentId),
        },
      ]
    },
  },
  created() {},
  methods: {
    filterTree(list, id) {
      if (id && list) {
        let realList = []
        realList = list.map((l) => {
          return {
            ...l,
            selectable: l.id != id,
            children: l.id == id ? this.filterTreetoSelected(l.children) : this.filterTree(l.children, id),
          }
        })
        return realList
      } else {
        return list
      }
    },
    filterTreetoSelected(list) {
      if (list) {
        return list.map((l) => ({ ...l, selectable: false, children: this.filterTreetoSelected(l.children) }))
      } else {
        return list
      }
    },
    debouncedGetAnswer() {
      this.treeData = JSON.parse(JSON.stringify(this.list))
    },
  },
  watch: {
    list: function (newQuestion, oldQuestion) {
      this.debouncedGetAnswer()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
